const { isProjectManager, isSpaceAdmin } = require('./roomAccessUi.cjs')
const { isProductionWorker } = require('./productionAccess.cjs')

function keepsCloudSession(userState = {}) {
  return isProjectManager(userState)
}

function loginLandingPath(userState = {}) {
  if (isProductionWorker(userState)) return '/workbench'
  return !keepsCloudSession(userState) && isSpaceAdmin(userState) ? '/building' : '/'
}

function logoutLandingPath(userState = {}) {
  return keepsCloudSession(userState) ? '/' : '/login'
}

module.exports = { keepsCloudSession, loginLandingPath, logoutLandingPath }
